var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgForAdultsIcon = function SvgForAdultsIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FDC13C",
    clipPath: "url(#forAdultsIcon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M22 11.8v4.8c0 1.6-1.3 3-3 3H4.2c-1.6 0-3-1.3-3-3V8.8c0-1.6 1.3-3 3-3h10.3v1.5H4.2c-.8 0-1.4.7-1.4 1.5v7.8c0 .8.7 1.5 1.5 1.5H19c.8 0 1.5-.7 1.5-1.5v-4.8zm-8201-6H8204zm0 0H8204zM23.4 7.3H22v1.5h-1.5V7.4c0-.1 0-.1-.1-.1H19V5.9h1.5V4.4H22v1.4h1.4z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.902 17.001v-2.5c0-2-.2-3.9-.8-5.7l1.9-.6c.6 1.9.9 4.1.9 6.2v2.5h-2zM16.1 17.302c-1.1-1.3-2.4-3.7-2.5-5.3-.1 1.6-1.4 4-2.6 5.3l-1.5-1.2c1.4-1.5 3.1-5.6 3.1-7.6h1.9c0 2 1.7 6.1 3.1 7.6z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "forAdultsIcon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgForAdultsIcon;